import type { FunctionComponent } from 'react';
import type { ManualNameSpellings, NameLocalizations } from '../../api/localization';

export interface LocalizedNameFieldsProps {
  original: string;
  stored?: NameLocalizations;
  manual: ManualNameSpellings;
  onChange: (patch: ManualNameSpellings) => void;
  disabled?: boolean;
  maxLength?: number;
}

/** Retired globally: forms keep their original name field only.
 * Preserve the interface for existing callers without displaying or submitting
 * alternate spellings. Previously saved data stays untouched.
 */
export const LocalizedNameFields: FunctionComponent<LocalizedNameFieldsProps> = () => null;
